import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from "react";
const UserGeneratedContentContext = createContext([]);
UserGeneratedContentContext.displayName = "ugc";
;
export const useUgcContext = () => useContext(UserGeneratedContentContext);
export const UserGeneratedContentProvider = ({ children, initialState, reducer }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (_jsx(UserGeneratedContentContext.Provider, { value: [state, dispatch], children: children }));
};
